import "./NewArrivals.css";
import { useState, useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { loadProducts } from "../../data/loadProducts";

const NewArrivals = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    async function fetchProducts() {
      const data = await loadProducts();
      setProducts(data.filter((item) => item.isNewArrival).slice(0, 4));
    }
    fetchProducts();
  }, []);

  return (
    <section className="new-arrivals">
      <div className="container">
        <div className="arrival-header">
          <div>
            <span className="just-in">JUST IN</span>
            <h2>New Arrivals</h2>
          </div>

          <Link to="/shop?filter=new" className="signature-view">
            VIEW ALL <FaArrowRight />
          </Link>
        </div>

        <div className="arrival-grid">
          {products.map((item) => {
            const currentPrice = Number(String(item.price ?? 0).replace(/[₹,\s]/g, "")) || 0;
            const oldPrice = Number(String(item.oldPrice ?? 0).replace(/[₹,\s]/g, "")) || 0;

            return (
              <Link
                key={item.id}
                to={`/product/${item.id}`}
                className="arrival-card-link"
              >
                <div className="arrival-card">
                  <div className="arrival-image">
                    <img src={item.image} alt={item.name} loading="lazy" />
                  </div>

                  <div className="arrival-content">
                    <span>{item.displayCategory || item.category}</span>
                    <h3>{item.name}</h3>

                    <div className="price-row">
                      <span className="new-price">
                        ₹{currentPrice.toLocaleString("en-IN")}
                      </span>
                      <span className="old-price">
                        ₹{oldPrice.toLocaleString("en-IN")}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default NewArrivals;